import { render, staticRenderFns } from "./wzDetail.vue?vue&type=template&id=3bbfe46c"
import script from "./wzDetail.vue?vue&type=script&lang=js"
export * from "./wzDetail.vue?vue&type=script&lang=js"
import style0 from "./wzDetail.vue?vue&type=style&index=0&id=3bbfe46c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports